var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('counter',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var quantityC = ref.quantityC;
var inputKey = ref.inputKey;
var input = ref.input;
return _c('div',{staticClass:"counter"},[_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(quantityC),expression:"quantityC"}],attrs:{"type":"tel"},domProps:{"value":(quantityC)},on:{"keypress":inputKey,"input":[function($event){if($event.target.composing){ return; }quantityC=$event.target.value},input]}})])])}}])},'counter',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }